import { Icon } from '@iconify/react';

// Indeterminate progress bar for requests whose duration isn't measurable —
// a punch, a save, an upload. Renders nothing unless `active`, so callers can
// mount it unconditionally and drive it from their loading flag.
//
// `color` is the moving bar's Tailwind background class; the track derives
// from it visually via a plain gray so any accent works.
const IndeterminateProgress = ({
    active = true,
    label,
    color = 'tw-bg-blue-500',
    className = '',
}) => {
    if (!active) return null;

    return (
        <div className={className}>
            <div
                role="progressbar"
                aria-busy="true"
                aria-label={label || 'Working'}
                className="tw-w-full tw-h-1 tw-rounded-full tw-bg-gray-100 tw-overflow-hidden"
            >
                <div className={`tw-h-full tw-w-1/5 tw-rounded-full tw-animate-progress-sweep ${color}`} />
            </div>
            {label && (
                <p className="tw-text-[11px] tw-text-gray-400 tw-mt-1.5 tw-mb-0 tw-flex tw-items-center tw-gap-1 tw-justify-center">
                    <Icon icon="mdi:loading" className="tw-animate-spin tw-text-xs" />
                    {label}
                </p>
            )}
        </div>
    );
};

export default IndeterminateProgress;
